/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import ProductFeatureGridItem from './ProductFeatureGridItem'

import styled from '@emotion/styled'

const StyledSection = styled('section')`
  display: flex;
  flex-wrap: wrap;
`

const ProductFeatureGrid = ({ children }) => (
  <StyledSection>{children}</StyledSection>
)

ProductFeatureGrid.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
}

export default ProductFeatureGrid
